import * as Sentry from '@sentry/react'

export const initSentry = () => {
  // Only initialize Sentry in production (not on localhost)
  const isProduction = process.env.NODE_ENV === 'production' && !window.location.hostname.includes('localhost')
  if (isProduction) {
    Sentry.init({
      dsn: 'https://a69ef943f0d4db815bb0de0bc4d09156@o4510378943315968.ingest.de.sentry.io/4510378992533584',
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      environment: process.env.NODE_ENV,
    })
    console.log('Sentry initialized for production environment')
  } else {
    console.log('Sentry disabled for local development')
  }
}
